<p><strong>Generate Random Points</strong></p>

<h3-horizontal-form [labelWidth]="2">
  <h3-horizontal-form-row>
    <mat-form-field appearance="outline">
      <mat-label>Total Points</mat-label>
      <input matInput [(ngModel)]="totalPoints" type="number" />
    </mat-form-field>
  </h3-horizontal-form-row>

  <h3-horizontal-form-row>
    <span label>Create points around sensor location</span>
    <mat-checkbox color="primary" [(ngModel)]="useSensorLocation">
      Use sensor location as origin for min/max coordinates
    </mat-checkbox>
  </h3-horizontal-form-row>

  <h3-horizontal-form-row>
    <span label>Min XY coordinate</span>
    <mat-form-field appearance="outline">
      <mat-label>Min Point X</mat-label>
      <input matInput [(ngModel)]="minPoint[0]" type="number" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Min Point Y</mat-label>
      <input matInput [(ngModel)]="minPoint[1]" type="number" />
    </mat-form-field>
  </h3-horizontal-form-row>

  <h3-horizontal-form-row>
    <span label>Max XY coordinate</span>
    <mat-form-field appearance="outline">
      <mat-label>Max Point X</mat-label>
      <input matInput [(ngModel)]="maxPoint[0]" type="number" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Max Point Y</mat-label>
      <input matInput [(ngModel)]="maxPoint[1]" type="number" />
    </mat-form-field>
  </h3-horizontal-form-row>

  <h3-horizontal-form-row>
    <span label>Cloud attributes to generate</span>
    <div class="cloud-attributes">
      <mat-checkbox
        *ngFor="let attribute of cloudAttributes"
        color="primary"
        [(ngModel)]="attribute.value"
      >
        {{ attribute.name | titlecase }}
      </mat-checkbox>
    </div>
  </h3-horizontal-form-row>

  <h3-horizontal-form-row>
    <button class="btn btn-default" (click)="createPoints()">
      Create Points
    </button>
    <button class="btn btn-primary" (click)="sortExistingPoints()">
      Sort Existing Points
    </button>
  </h3-horizontal-form-row>
</h3-horizontal-form>
